import {useContext, useState} from "react";
import {AuthContext} from "../context/AuthContext";
import {CerberusContext} from "@a11n-io/cerberus-reactjs";

export default function useFetch(baseUrl) {
    const [loading, setLoading] = useState(false);
    const authCtx = useContext(AuthContext)
    const cerberusCtx = useContext(CerberusContext)

    const defaultHeaders = {
        "Content-Type": "application/json"
    }

    let hdrs = defaultHeaders
    if (cerberusCtx.apiTokenPair) {
        hdrs = { ...hdrs, Authorization: 'Bearer ' + cerberusCtx.apiTokenPair.accessToken }
    }

    function get(url, headers) {
        hdrs = { ...hdrs, ...headers }

        return new Promise((resolve, reject) => {
            setLoading(true);
            fetch(`${process.env.REACT_APP_CERBERUS_WEB_HOST}${baseUrl}${url}`, {
                credentials: "include",
                method: "get",
                headers: hdrs
            })
                .then((response) => {
                    setLoading(false)
                    if (response.ok) {
                        return response.json()
                    }
                    if (response.status === 401 || response.status === 403) {
                        authCtx.logout();
                    }
                    return Promise.reject(response)
                })
                .then((data) => {
                    if (data === null) {
                        data = []
                    }
                    resolve(data)
                })
                .catch((response) => {
                    response.json().then((json) => {
                        if (typeof json !== 'string' && Object.hasOwn(json, 'message')) {
                            reject(json.message)
                        }
                        reject(json)
                    })
                })
        });
    }

    function post(url, body, headers) {
        hdrs = { ...hdrs, ...headers }

        return new Promise((resolve, reject) => {
            setLoading(true);
            fetch(`${process.env.REACT_APP_CERBERUS_WEB_HOST}${baseUrl}${url}`, {
                credentials: "include",
                method: "post",
                headers: hdrs,
                body: JSON.stringify(body)
            })
                .then((response) => {
                    setLoading(false)
                    if (response.ok) {
                        return response.json()
                    }
                    if (response.status === 401 || response.status === 403) {
                        authCtx.logout();
                    }
                    return Promise.reject(response)
                })
                .then((data) => {
                    if (data === null) {
                        data = []
                    }
                    resolve(data)
                })
                .catch((response) => {
                    response.json().then((json) => {
                        if (typeof json !== 'string' && Object.hasOwn(json,'message')) {
                            reject(json.message)
                        }
                        reject(json)
                    })
                })
        });
    }

    function put(url, body, headers) {
        hdrs = { ...hdrs, ...headers }

        return new Promise((resolve, reject) => {
            setLoading(true);
            fetch(`${process.env.REACT_APP_CERBERUS_WEB_HOST}${baseUrl}${url}`, {
                credentials: "include",
                method: "put",
                headers: hdrs,
                body: JSON.stringify(body)
            })
                .then((response) => {
                    setLoading(false)
                    if (response.ok) {
                        return response.json()
                    }
                    if (response.status === 401 || response.status === 403) {
                        authCtx.logout();
                    }
                    return Promise.reject(response)
                })
                .then((data) => {
                    if (data === null) {
                        data = []
                    }
                    resolve(data)
                })
                .catch((response) => {
                    response.json().then((json) => {
                        if (typeof json !== 'string' && Object.hasOwn(json,'message')) {
                            reject(json.message)
                        }
                        reject(json)
                    })
                })
        });
    }

    function del(url, headers) {
        hdrs = { ...hdrs, ...headers }

        return new Promise((resolve, reject) => {
            setLoading(true);
            fetch(`${process.env.REACT_APP_CERBERUS_WEB_HOST}${baseUrl}${url}`, {
                credentials: "include",
                method: "delete",
                headers: hdrs
            })
                .then((response) => {
                    setLoading(false)
                    if (response.ok) {
                        return response.json()
                    }
                    if (response.status === 401 || response.status === 403) {
                        authCtx.logout();
                    }
                    return Promise.reject(response)
                })
                .then((data) => {
                    if (data === null) {
                        data = []
                    }
                    resolve(data)
                })
                .catch((response) => {
                    response.json().then((json) => {
                        if (typeof json !== 'string' && Object.hasOwn(json,'message')) {
                            reject(json.message)
                        }
                        reject(json)
                    })
                })
        });
    }

    function postFiles(url, form) {
        return new Promise((resolve, reject) => {
            setLoading(true);
            fetch(`${process.env.REACT_APP_CERBERUS_WEB_HOST}${baseUrl}${url}`, {
                credentials: "include",
                method: "post",
                headers: hdrs,
                body: form
            })
                .then((response) => {
                    setLoading(false)
                    if (response.ok) {
                        return response.json()
                    }
                    if (response.status === 401 || response.status === 403) {
                        authCtx.logout();
                    }
                    return Promise.reject(response)
                })
                .then((data) => {
                    if (data === null) {
                        data = []
                    }
                    resolve(data)
                })
                .catch((response) => {
                    response.json().then((json) => {
                        if (typeof json !== 'string' && Object.hasOwn(json,'message')) {
                            reject(json.message)
                        }
                        reject(json)
                    })
                })
        });
    }

    return { get, post, put, del, postFiles, loading };
};